import $ from 'jquery'

class Navbar {
	//? 1. describe and create/initiate our object

	constructor() {
		//Verables
		this.events()
	}

	//?events
	events() {
		let myObj = this

		$('.open-btn').click(function () {
			myObj.openDrawer()
		})
		let currentWidth = $(window).width()

		$(window).resize(function () {
			let newWidth = $(window).width()
			if (newWidth > currentWidth || newWidth < currentWidth) {
				location.reload()
			}
		})

		myObj.footerGlow()
	}

	//? 3. methods (functions)
	openDrawer() {
		console.log('open Drawer')
		this.drawerToggle = this.drawerToggle ? false : true
		$('#nav-ovelay').toggleClass('hide')
		if (this.drawerToggle) {
			$('.open-btn').attr(
				'src',
				'/wp-content/uploads/2022/05/close-icon.png'
			)
			$('#mobile-nav').removeClass('tiny')
		} else {
			$('.open-btn').attr(
				'src',
				'/wp-content/uploads/2022/05/mobile-hamberger.png'
			)
			$('#mobile-nav').addClass('tiny')
		}
	}

	footerGlow() {
		let footerTL = new TimelineMax()
		footerTL.add('start', 0).from('.gradient-ov', 2, { opacity: 0 })

		var controller = new ScrollMagic.Controller()

		// build scene
		var scene = new ScrollMagic.Scene({
			triggerElement: '#heroFooter',
			offset: -200,
			// duration: 350,
		})
			// .addIndicators({
			// 	name: ' cans',
			// 	colorTrigger: 'red',
			// 	colorStart: 'red',
			// 	colorEnd: 'red',
			// 	indent: 500,
			// })

			.setTween(footerTL)

			.addTo(controller)
	}
	openOverlay() {}
}

export default Navbar
